import { useEffect, useRef } from "react";

/**
 * Render INSIDE the <form>. Populates:
 * - certField (e.g., "trusteformcerturl")
 * - pingField (e.g., "trustedformpingurl")
 * - tokenField (e.g., "trustedformtoken")
 */
export default function TrustedFormCapture({
  certField = "trusteformcerturl",
  pingField = "trustedformpingurl",
  tokenField = "trustedformtoken",
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.innerHTML = "";

    const s = document.createElement("script");
    s.async = true;
    s.type = "text/javascript";
    s.src =
      `https://api.trustedform.com/trustedform.js` +
      `?field=${encodeURIComponent(certField)}` +
      `&ping_field=${encodeURIComponent(pingField)}` +
      `&token_field=${encodeURIComponent(tokenField)}`;

    ref.current?.appendChild(s);

    const ns = document.createElement("noscript");
    const img = document.createElement("img");
    img.src = "https://api.trustedform.com/ns.gif";
    img.alt = "";
    ns.appendChild(img);
    ref.current?.appendChild(ns);
  }, [certField, pingField, tokenField]);

  return <span ref={ref} />;
}
